window.addEventListener("load", function () {
    const SELLING_PLAN_ID = "1692139660";

    // ===== テスト用 =====
    // null = 実際の現在日時を使用
    // テスト時は "2028-02-01T12:00:00+09:00" のように指定
    const TEST_DATE = null;
    // ====================

    // GO SUBのselling plan inputを取得
    const sellingPlanInputs = Array.from(
        document.querySelectorAll(
            'input[data-gosub-selling-plan-id-input]'
        )
    );

    // 対象プランに一致するフォームを取得
    const forms = sellingPlanInputs
        .filter(input => input.value === SELLING_PLAN_ID)
        .map(input => input.closest("form.js-product-form"))
        .filter(Boolean);

    // 重複を除去
    const uniqueForms = [...new Set(forms)];

    // テスト日または現在日時
    const now = TEST_DATE ? new Date(TEST_DATE) : new Date();

    const parts = new Intl.DateTimeFormat("ja-JP", {
        timeZone: "Asia/Tokyo",
        year: "numeric",
        month: "numeric",
        day: "numeric"
    }).formatToParts(now);

    const year = Number(
        parts.find(part => part.type === "year").value
    );

    const month = Number(
        parts.find(part => part.type === "month").value
    );

    const day = Number(
        parts.find(part => part.type === "day").value
    );

    // 今月の日数
    const daysInMonth = new Date(year, month, 0).getDate();

    // 30日以下の月の1日は申込休止
    const isClosedToday =
        day === 1 && daysInMonth < 31;

    if (!isClosedToday) {
        return;
    }

    // すべての対象フォームのボタンを停止
    uniqueForms.forEach(form => {
        const button = form.querySelector(
            'button.add-to-cart[type="submit"]'
        );

        if (!button) {
            return;
        }

        button.disabled = true;
        button.setAttribute("aria-disabled", "true");
        button.textContent = `次回お申し込みは${month}月2日開始`;
    });
});